import { Component, OnInit } from '@angular/core';
import { SuperAdminService } from 'src/app/super-admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-monthly-expense',
  templateUrl: './monthly-expense.component.html',
  styleUrls: ['./monthly-expense.component.css']
})
export class MonthlyExpenseComponent implements OnInit {
  expenseArr:any=[];
  expenseArray:any=[];
  myArr:any=[];
  paramId:any;
  month:any;
  userSessionData:any=JSON.parse(sessionStorage.getItem('userSession'));
  monthArr : any=["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
  monthArrFull : any=["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  year: any;
  constructor( private activatedRoute: ActivatedRoute, private router: Router,private toastr: ToastrService, private superadminService: SuperAdminService) { 
    this.activatedRoute.params.subscribe(param => {
      this.paramId = param.id;
      this.month = this.monthArrFull[this.monthArr.indexOf(this.paramId)];
      this.year = param.year;
    })
   }
  ngOnInit(): void {
    this.getExpenseGroup()
  }
  // getExpense() {
  //   this.superadminService.getAllExpense()
  //     .subscribe((res: { status: any, message: any, data: any }) => {
  //       if(res.status == true ){
  //         this.myArr= res.data;
  //         if(this.userSessionData.user_role_id[0]!=1){
  //           this.myArr = this.myArr.filter((item)=>{
  //             return item.SupervisorName==this.userSessionData.full_name
  //           })
  //         }
  //       for(let i=0; i<this.myArr.length; i++){
  //         if(this.monthArr[this.myArr[i].expenseDate.split('-')[1]-1]==this.paramId){
  //           this.month= this.monthArrFull[this.myArr[i].expenseDate.split('-')[1]-1]
  //           this.expenseArr.push({"month":this.paramId,"supervisorName":this.myArr[i].SupervisorName,"companyName":this.myArr[i].companyName, "amount":this.myArr[i].totalExpenseAmount  })
  //       }
  //     }
  //       }else{
  //         if (res.status == 401) {
  //           this.toastr.error(res.message);
  //           window.sessionStorage.clear();
  //           this.router.navigateByUrl('superAuth/login');
            
  //         }else {
  //           this.toastr.error(res.message);
  //         }
  //       } 
  //     }
  //     )
  // }
  getExpenseGroup() {
    this.superadminService.getMasterDataGroup()
      .subscribe((res: { status: any, message: any, data: any }) => {
        if(res.status == true ){
          this.superadminService.getClientList()
            .subscribe((client: { status: any, message: any, data: any }) => {
              if (client.status == true) {
                this.myArr= res.data;
                this.myArr = this.myArr.filter((item)=>{
                  return item._id.year == this.year
                })
                if(this.userSessionData.user_role_id[0]!=1){
                  this.myArr = this.myArr.filter((item)=>{
                    return item._id.supervisorId==this.userSessionData._id
                  })
                }
                // console.log("myArr",this.myArr)
                this.myArr = this.myArr.filter((item)=>{
                  return this.monthArr[item._id.month-1] == this.paramId
                })
                // console.log("month---MYARR",this.myArr)
                for(let i=0; i<this.myArr.length; i++){
                  this.expenseArr.push({"supervisorId":this.myArr[i]._id.supervisorId,"companyId":this.myArr[i]._id.companyId, "amount":this.myArr[i].totalExpenseAmount  })
                }
                // console.log("this.expenseArr after comparing",this.expenseArr)
                this.expenseArr.forEach((x, index) => {
                  client.data.filter(y => {
                    if (y._id == x.companyId) this.expenseArr[index].companyName = y.clientName
                  })
                })
                this.superadminService.getSuperVisorName().subscribe((supervisors: {status: any, message: any, data: any}) => {
                  if(supervisors.status == true){
                    var supervisorsData = supervisors.data;
                    this.expenseArr.forEach((item,i)=>{
                      this.expenseArr[i].SupervisorName = supervisorsData.filter((item)=> this.expenseArr[i].supervisorId==item._id);
                      this.expenseArr[i].SupervisorName = this.expenseArr[i].SupervisorName[0]?this.expenseArr[i].SupervisorName[0]['full_name']:this.expenseArr[i].SupervisorName[0]
                    })
                    this.expenseArray = this.expenseArr;
                    console.log("this.expenseArray",this.expenseArray)
                  }else{
                    console.log(res.message);
                  }
                }, error => {
                  console.log('error', error);
                })
              }
              else {
                if (res.status == 401) {
                  this.toastr.error(res.message);
                  window.sessionStorage.clear();
                  this.router.navigateByUrl('superAuth/login');

                } else {
                  this.toastr.error(res.message);
                }
              }

            }, error => {
            });
        }else{
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl('superAuth/login');
            
          }else {
            this.toastr.error(res.message);
          }
        } 
      }
      )
  }

backTo(){
  window.history.back()
}
}
